import { useDashboardCardPeriodCaption } from '@/customHooks/useDashboardCardPeriodCaption';

type Props = {
  tightTop?: boolean;
};

export const DashboardCardPeriodCaption = ({ tightTop }: Props) => {
  const line = useDashboardCardPeriodCaption();
  if (!line) return null;
  return (
    <p className={tightTop ? 'mt-0.5 mb-0 text-xs font-medium leading-[1.35] text-gray-500' : 'mb-[0.45rem] mt-0 text-xs font-medium leading-[1.35] text-gray-500'}>
      {line}
    </p>
  );
};
